// Dispatcher: routes a survey access to the correct flow component based on the survey slug.
import { useEffect, useState } from 'react'
import { useParams, Link } from 'react-router-dom'
import { api } from '../lib/api.js'
import MiWayFlow from './MiWayFlow.jsx'
import MyCultureFlow from './MyCultureFlow.jsx'
import ProResFlow from './ProResFlow.jsx'
import { AlertCircle } from 'lucide-react'

export default function SurveyFlow() {
  const { accessId } = useParams()
  const [state, setState] = useState({ loading: true, slug: null, surveyName: null, error: null })

  useEffect(() => {
    let cancelled = false
    api.myResponses()
      .then(items => {
        if (cancelled) return
        const item = items.find(i => i.accessId === accessId)
        if (!item) {
          setState({ loading: false, slug: null, error: 'Zugang nicht gefunden.' })
          return
        }
        setState({ loading: false, slug: item.survey.slug, surveyName: item.survey.name, error: null })
      })
      .catch(e => !cancelled && setState({ loading: false, slug: null, error: e.message }))
    return () => { cancelled = true }
  }, [accessId])

  if (state.loading) return <div className="text-center py-12 text-ink-soft">Lade Umfrage…</div>
  if (state.error) return <ErrorView title="Fehler" message={state.error} />
  if (state.slug === 'miway-4') return <MiWayFlow />
  if (state.slug === 'myculture-pref') return <MyCultureFlow />
  if (state.slug === 'prores-2-5') return <ProResFlow />

  return (
    <ErrorView
      title="Umfrage noch nicht verfügbar"
      message={`Die Umfrage „${state.surveyName}" ist in dieser Version der Plattform noch nicht implementiert.`}
    />
  )
}

function ErrorView({ title, message }) {
  return (
    <div className="max-w-2xl mx-auto card p-8 text-center">
      <div className="w-12 h-12 rounded-full bg-amber-100 text-amber-600 grid place-items-center mx-auto mb-4">
        <AlertCircle size={24} />
      </div>
      <h1 className="text-xl font-bold mb-2">{title}</h1>
      <p className="text-ink-soft mb-6">{message}</p>
      <Link to="/" className="btn-secondary">Zurück zur Übersicht</Link>
    </div>
  )
}
